export const accordionChange = (payload) => ({
  type: accordionChange.toString(),
  payload
})
accordionChange.toString = () => 'menu/accordionChange'

export const indicatorTabChange = (payload) => ({
  type: indicatorTabChange.toString(),
  payload
})
indicatorTabChange.toString = () => 'menu/indicatorTabChange'

export const externalTabChange = (payload) => ({
  type: externalTabChange.toString(),
  payload
})
externalTabChange.toString = () => 'menu/externalTabChange'

const menuReducer = {
  [accordionChange]: (draftState, { id, type }) => {
    draftState.openAccordions[type] === id
      ? (draftState.openAccordions[type] = '')
      : (draftState.openAccordions[type] = id)
  },
  [indicatorTabChange]: (draftState, isOpen) => {
    draftState.showSelectedIndicatorLayers = isOpen
  },
  [externalTabChange]: (draftState, isOpen) => {
    draftState.showSelectedExternalLayers = isOpen
  }
}

export default menuReducer
